import {defineSlotRecipe} from '@chakra-ui/react3'

export default defineSlotRecipe({
    slots: ['root', 'container', 'price', 'cta', 'listPrice'],
    base: {
        root: {
            display: 'inline-flex',
            alignItems: 'center',
            paddingLeft: 'spacing-20',
            paddingRight: 'spacing-4',
            paddingTop: 'spacing-4',
            paddingBottom: 'spacing-4',
            borderRadius: 'round',
            backdropFilter: 'blur(8px)'
        },
        container: {
            display: 'grid',
            gridAutoFlow: {base: 'row', xs: 'column'},
            justifyItems: 'start',
            alignItems: 'baseline',
            columnGap: 'spacing-6',
            flex: '0 1 auto',
            width: 'max-content',
            maxWidth: '100%'
        },
        price: {
            whiteSpace: 'nowrap'
        },
        listPrice: {
            textDecoration: 'line-through',
            whiteSpace: 'nowrap',
            textStyle: 'heading.small',
            paddingLeft: 'spacing-4',
            paddingRight: 'spacing-4',
            borderRadius: 'xs',
            bg: 'background.actions.ghost',
            color: 'text.secondary'
        },
        cta: {
            flex: '1 1 auto',
            minWidth: 0
        }
    },
    variants: {
        size: {
            small: {
                root: {
                    textStyle: 'body.small',
                    gap: 'spacing-12'
                },
                cta: {
                    size: 'md'
                }
            },
            large: {
                root: {
                    textStyle: 'body.medium',
                    gap: 'spacing-16'
                },
                cta: {
                    size: 'lg'
                }
            }
        },
        hasPrice: {
            true: {},
            false: {
                root: {
                    display: 'contents'
                },
                cta: {
                    size: 'lg'
                }
            }
        },
        variant: {
            default: {
                root: {
                    bg: 'background.actions.ghost',
                    color: 'text.primary'
                }
            },
            'on-media': {
                root: {
                    bg: 'background.actions.on-media.ghost',
                    color: 'text.on-media.primary'
                },
                listPrice: {
                    bg: 'background.actions.on-media.ghost',
                    color: 'text.on-media.primary'
                }
            },
            // comparison table module: not part of price button group, but reused for the price display without providing CTA
            comparisonTable: {
                root: {
                    bg: 'transparent',
                    color: 'text.primary'
                }
            },
            // teaser module: not part of price button group, but reused for the price display without providing CTA
            plain: {
                root: {
                    bg: 'transparent',
                    paddingX: 0
                },
                container: {columnGap: 'spacing-4'},
                price: {
                    color: 'text.secondary',
                    textStyle: 'heading.medium'
                },
                listPrice: {
                    textStyle: 'body.small'
                }
            }
        }
    },
    defaultVariants: {
        size: 'large',
        hasPrice: true,
        variant: 'default'
    }
})
